function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.48,55.34H13a5.84,5.84,0,0,1-5.84-5.83V13.6A5.85,5.85,0,0,1,13,7.76H43.16A5.85,5.85,0,0,1,49,13.6v8.93a1.77,1.77,0,0,1-3.53,0V13.6a2.31,2.31,0,0,0-2.31-2.32H13a2.32,2.32,0,0,0-2.32,2.32V49.51A2.32,2.32,0,0,0,13,51.82h9.48a1.76,1.76,0,1,1,0,3.52Z"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 15.51,
  y: 17.61,
  width: 22.3,
  height: 3.52,
  rx: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 15.75,
  y: 25.46,
  width: 12.84,
  height: 3.52,
  rx: 1.5
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 15.75,
  y: 33.18,
  width: 7.48,
  height: 3.52,
  rx: 1.5
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M41.52,57.85A15.32,15.32,0,1,1,56.84,42.53,15.35,15.35,0,0,1,41.52,57.85Zm0-27.12a11.8,11.8,0,1,0,11.8,11.8A11.81,11.81,0,0,0,41.52,30.73Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M40.73,47.83a2.76,2.76,0,0,1-2-.82l-3.33-3.32a1.76,1.76,0,0,1,2.49-2.49L40.73,44,46,38.76a1.76,1.76,0,1,1,2.49,2.49L42.71,47A2.78,2.78,0,0,1,40.73,47.83Z"
});

function SvgHandle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "02_\u5904\u7406\u6570") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandle);
export default __webpack_public_path__ + "static/media/handle.a4a5ae06.svg";
export { ForwardRef as ReactComponent };